import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import PcomValidation from '@js/plugins/validation.js';
import store from '@js/store/index.js';
import PcomPlugin from '@js/plugins/pcom.js';
import VueCookies from 'vue-cookies';
import PuIcon from '@pu/js/components/PuIcon.js';
import lozad from '@pu/js/mixins/lozad.js';

Vue.use(PcomPlugin);
Vue.use(VueCookies);
Vue.use(PcomValidation);

window.EventBus = new Vue();

Vue.use(VueAnalytics, {
    id: 'UA-7012908-4',
});

// Global components
Vue.component('PuIcon', PuIcon);

if (document.getElementById('app')) {
    /* Register our main Vue instance */

    var vm = new Vue({
        el: '#app',
        name: 'PcomRoot',
        components: {
            // Pages
            'home-page': () => import('@js/pages/home/PageHome.vue'),
            'tutor-me-page': () => import('@js/pages/tutor-me/TutorMe.vue'),
            'contact-us-page': () => import('@js/pages/ContactUs.vue'),
            'user-profile-page': () => import('@js/pages/user-profile/UserProfile.vue'),
            'user-dashboard-page': () => import('@js/pages/user-dashboard/UserDashboardPage.vue'),
            'b2b-schools-page': () => import('@js/pages/b2b/PageB2BSchools.vue'),
            'marketing-page': () => import('@js/pages/marketing/PageMarketing.vue'),
            'page-404': () => import('@js/pages/Page-404.vue'),
            'page-410': () => import('@js/pages/Page-410.vue'),
            'faq-page': () => import('@js/pages/faq/FAQPage.vue'),
            'feedback-page': () => import('@js/pages/feedback/FeedbackPage.vue'),
            'report-issue-page': () => import('@js/pages/report-issue/ReportIssue.vue'),
            // Components
            'the-header': () => import('@pu/js/components/TheHeader.vue'),
            'the-footer': () => import('@pu/js/components/TheFooter.vue'),
            'user-saved-scholarships': () => import('@js/components/UserSavedScholarships.vue'),
            'save-school': () => import('@js/components/SaveSchool.vue'),
            'user-saved-schools': () => import('@js/components/UserSavedSchools.vue'),
            'user-saved-school': () => import('@js/components/UserSavedSchool.vue'),
            'delete-school-modal': () => import('@js/components/DeleteSchoolModal.vue'),
            'school-list': () => import('@js/components/SchoolList.vue'),
            'cookie-banner': () => import('@pu/js/components/CookieBanner.vue'),
            'search-school': () => import('@js/components/Search/SearchSchool.vue'),
            'search-online': () => import('@js/components/Search/SearchOnline/SearchOnline.vue'),
            'search-grad': () => import('@js/components/Search/SearchGrad/SearchGrad.vue'),
            'scholarship-search': () => import('@js/components/ScholarshipSearch/ScholarshipSearch.vue'),
            'school-profile': () => import('@js/components/SchoolProfile.js'),
            'scholarship-profile': () => import('@js/components/ScholarshipProfile.js'),
            'resource-page': () => import('@js/components/ResourcePage.js'),
            'pcom-auth-page': () => import('@js/components/PcomAuthPage.js'),
            'pu-notifications': () => import('@pu/js/components/PuNotifications.vue'),
        },
        mixins: [lozad],
        store: store,
        mounted() {
            this.initCJ();
            this.initPromo();
            this.initFormsValidation();
        },
        methods: {
            // Sets cookie when website is accessed via affiliate link
            initCJ() {
                const params = new URLSearchParams(window.location.search);
                const cjeventid = params.get('cjevent');
                const now = new Date();
                const time = now.getTime();
                const expTime = time + 1000 * 31536000;
                now.setTime(expTime);
                if (cjeventid != '') {
                    document.cookie = 'cjevent=' + cjeventid + '; expires=' + now.toGMTString() + '; path=/';
                }
            },
            initPromo() {
                const $cookiePromo = document.querySelector('.promo-container');

                if (!$cookiePromo) {
                    return;
                }

                if (!localStorage.getItem('cookiePromo')) {
                    $cookiePromo.classList.add('show');
                }

                document.querySelectorAll('.promo-container .promo-close, .promo-container .btn-enter').forEach(($link) => {
                    $link.addEventListener('click', () => {
                        localStorage.setItem('cookiePromo', true);
                        $cookiePromo.classList.remove('show');
                    });
                });
            },
            initFormsValidation() {
                // Fetch all the forms we want to apply custom Bootstrap validation styles to
                const forms = document.querySelectorAll('.needs-validation');

                // Loop over them and prevent submission
                forms.forEach(($form) => {
                    $form.addEventListener(
                        'submit',
                        (event) => {
                            if ($form.checkValidity() === false) {
                                event.preventDefault();
                                event.stopPropagation();
                            }
                            $form.classList.add('was-validated');
                        },
                        false
                    );
                });
            },
        },
    });
} else {
    console.warn('Vue not initialized, check Blade template!');
}
